document.addEventListener('alpine:init', function () {
    Alpine.data('globalAlert', function (uniqueID) {
        return {
            storageKey: "global-alert-".concat(uniqueID),
            visible: true,
            init: function () {
                var _this = this;
                if (sessionStorage.getItem(this.storageKey)) {
                    this.visible = false;
                    return;
                }
                // Communicate height to the header so it can offset below the alert.
                this.$nextTick(function () {
                    _this.$store.app.globalAlertHeight = _this.$el.offsetHeight;
                });
            },
            close: function () {
                var _this = this;
                this.visible = false;
                this.$nextTick(function () {
                    _this.$store.app.globalAlertHeight = 0;
                });
                sessionStorage.setItem(this.storageKey, '1');
                this.$store.app.track({
                    event: 'close_global-alert',
                    type: 'click',
                    module: 'global-alert',
                });
            },
        };
    });
});
